$(document).ready(function () {
  let menu_btn = document.querySelector(".mobile-menu");
  let list = document.querySelector(".list");
  let side_menu = document.querySelector(".side_menu");
  let side_bar = document.querySelector(".side_bar");
  let main = document.querySelector(".main");
  if (menu_btn != null){
  menu_btn.addEventListener("click", () => {
    list.classList.toggle("open_list");
    menu_btn.classList.toggle("open_mobile-menu");
   });
  }
  let menu_item = document.querySelectorAll(".list_item");
  if (menu_item != null){
  for (let i = 0; i < menu_item.length; i++) {
    menu_item[i].addEventListener("click", () => {
      menu_btn.classList.remove("open_mobile-menu");
      list.classList.remove("open_list");
     });
   }
  }

  let shrink_btn = document.querySelector(".shrink");
  let expand_btn = document.querySelector(".expand");
  if (shrink_btn != null){
    shrink_btn.addEventListener("click", () => {
      shrink_btn.classList.toggle("close_shrink");
      expand_btn.classList.toggle("open_expand");
      side_menu.classList.toggle("close_side_menu");
      side_bar.classList.toggle("close_side_bar");
      main.classList.toggle("close_main");
    });
  }
  if (expand_btn != null){
    expand_btn.addEventListener("click", () => {
      shrink_btn.classList.toggle("close_shrink");
      expand_btn.classList.toggle("open_expand");
      side_menu.classList.toggle("close_side_menu");
      side_bar.classList.toggle("close_side_bar");
      main.classList.toggle("close_main");
    });
  }
  let right_set_btn = document.querySelector("#right_set");
  let sub_right_set = document.querySelector("#sub_right_set");
  if (right_set_btn != null){
    right_set_btn.addEventListener("click", () => {
      sub_right_set.classList.toggle("open_sub_list"); 
    });
  }
  let report_work_btn = document.querySelector("#report_work");
  let sub_report_work = document.querySelector("#sub_report_work");
  if (report_work_btn != null){
    report_work_btn.addEventListener("click", () => {
      sub_report_work.classList.toggle("open_sub_list"); 
    });
  }
  let partner_area_btn = document.querySelector("#partner_area");
  let sub_partner_area = document.querySelector("#sub_partner_area");
  if (partner_area_btn != null){
    partner_area_btn.addEventListener("click", () => {
      sub_partner_area.classList.toggle("open_sub_list"); 
    });
  }
  let risk_control_btn = document.querySelector("#risk_control");
  let sub_risk_control = document.querySelector("#sub_risk_control");
  if (risk_control_btn != null){
    risk_control_btn.addEventListener("click", () => {
      sub_risk_control.classList.toggle("open_sub_list"); 
    });
  }
  let import_data_btn = document.querySelector("#import_data");
  let sub_import_data = document.querySelector("#sub_import_data");
  if (import_data_btn != null){
    import_data_btn.addEventListener("click", () => {
      sub_import_data.classList.toggle("open_sub_list");
    });
  }
  let comprehensive_loan_btn = document.querySelector("#comprehensive_loan");
  let sub_comprehensive_loan = document.querySelector("#sub_comprehensive_loan");
  if (comprehensive_loan_btn != null){
    comprehensive_loan_btn.addEventListener("click", () => {
      sub_comprehensive_loan.classList.toggle("open_sub_list");
    });
  }

});